import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WebinarsRoutingModule } from './webinars-routing.module';
import { WebinarsComponent } from 'src/app/Components/webinar/webinars/webinars.component';
import { Webinar01Component } from 'src/app/Components/webinar/webinar01/webinar01.component';
import { Webinar02Component } from 'src/app/Components/webinar/webinar02/webinar02.component';
import { Webinar03Component } from 'src/app/Components/webinar/webinar03/webinar03.component';
import { Webinar04Component } from 'src/app/Components/webinar/webinar04/webinar04.component';
import { UpcomingEventComponent } from 'src/app/Components/webinar/upcoming-event/upcoming-event.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/models/material-components.service';
import { MaterialModuleList } from 'src/app/material-module';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared.module';
// import { Webinar012024Component } from 'src/app/Components/webinar/webinar012024/webinar012024.component';


@NgModule({
  declarations: [
    WebinarsComponent,
    //Webinar012024Component,
    Webinar01Component,
    Webinar02Component,
    Webinar03Component,
    Webinar04Component,
    UpcomingEventComponent
  ],
  imports: [
    CommonModule,
    WebinarsRoutingModule,
    ReactiveFormsModule,
    MaterialModule,
    MaterialModuleList,
    FormsModule,
    HttpClientModule,
    SharedModule
  ]
})
export class WebinarsModule { }
